import React, { useState, useEffect, ChangeEvent } from 'react';
import Textarea from '../../Form/Textarea';
import Input from '../../Form/Input';
import UploadFiles from 'components/Form/UploadFiles';

interface TypeProps {
  data: any,
  handleSelectChange: Function,
  handleInputChange: Function,
  setData: Function,
}

export default function VistoriaImovel({ data, handleSelectChange, handleInputChange, setData }: TypeProps) {


  return (
    <form>
      <Input
        name="endereco"
        label="Endereço"
        type="text"
        placeholder={'Endereço'}
        data={data?.endereco || ''}
        setData={handleInputChange}
        disabled={true}
      />

      <Textarea
        name="relatoImovelAreaServico"
        label="Área de Serviço"
        placeholder={'Área de Serviço'}
        data={data?.relatoImovelAreaServico || ''}
        setData={handleInputChange}
      />

      <Textarea
        name="relatoImovelSala"
        label="Sala"
        placeholder={'Sala'}
        data={data?.relatoImovelSala || ''}
        setData={handleInputChange}
      />

      <Textarea
        name="relatoImovelDormitorio"
        label="Dormitório"
        placeholder={'Dormitório'}
        data={data?.relatoImovelDormitorio || ''}
        setData={handleInputChange}
      />

      <Textarea
        name="relatoImovelQuintal"
        label="Quintal"
        placeholder={'Quintal'}
        data={data?.relatoImovelQuintal || ''}
        setData={handleInputChange}
      />
      <Textarea
        name="relatoImovelCorredor"
        label="Corredor"
        placeholder={'Corredor'}
        data={data?.relatoImovelCorredor || ''}
        setData={handleInputChange}
      />
      <Textarea
        name="relatoImovelCozinha"
        label="Cozinha"
        placeholder={'Cozinha'}
        data={data?.relatoImovelCozinha || ''}
        setData={handleInputChange}
      />
      <Textarea
        name="relatoImovelBanheiro"
        label="Banheiro"
        placeholder={'Banheiro'}
        data={data?.relatoImovelBanheiro || ''}
        setData={handleInputChange}
      />

      {
        data.id &&
        <UploadFiles
          name="images"
          label="Inserir imagens e/ou documentos dos tipos: PNG, JPEG, JPG e PDF"
          osId={data?.id}
          etapa={'imovel'}
        />
      }
    </form>
  )
}
